import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { AllTransferStationTransactions } from "../../../Apis/TransferStationReport/allTransferStationTransactionApi";
import TableComponent from "../../../Common/TableComponent/tableComponent";
import ExcelJS from "exceljs";
import isGHMC, { getCurrentDateTime1, getToken } from "../../../Common/helper/helpar";
import { GetZone } from "../../../Apis/organizationApi";
import { AllVehicleTypeDetails } from "../../../Apis/vehicleApi";
import EditTransferstationTransactionModal from "./editTransferstationTransactionModal";
import { TableLoader } from "../../../Common/ShimmerLoader";
import { exportToPDF } from "../../../../utils/exportToPDF";
import SmallLoader from "../../../../Hooks/SmallLoader";
import axiosInstance from "../../../../Hooks/axoisInstance";
import { API_BASE_URL1 } from "../../../Services/baseApiUrl";
import Select from "react-select";
const TransferStationTransaction = ({ t }) => {
  const headers = [
    "vehicleUid",
    "vehicleNumber",
    "zone",
    // "circle",
    "ward",
    "vehicleType",
    "ownerType",
    "tsincharge",
    "tsname",
    "deploymentDate",
    "grossWeight",
    "tareWeight",
    "netWeight",
    // "lmcSlipNO",
    "latitude",
    "longitude",
    // "address",
    "image",
    // "Slip Image",
    // "actions",
  ];
  const [vehicleTypeDetails, setVehicleTypeDetails] = useState([]);
  const [getAllTripsTonnage, setAllTripsTonnage] = useState([]);
  const [startDate, setStartDate] = useState(getStartOfCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDateTime());
  const [VehicleNumber, setVehicleNumber] = useState("");
  const [selectedVehicleTypes, setSelectedVehicleTypes] = useState([]);
  const [allZones, setAllZones] = useState([]);
  const [zoneId, setZoneId] = useState("");
  const [lgShow, setLgShow] = useState(false);
  const [editData, setEditData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [IsExcelDowanload, setIsExcelDowanload] = useState(false);
  const isProd = isGHMC();
  useEffect(() => {
    fetchTripsTonnageData(startDate, endDate, "", "", "", "", "", "", "");
    fetchAllDataDetails();
  }, []);

  useEffect(() => {
    if (!Array.isArray(allZones) || allZones.length === 0) return;

    setZoneId((currentZoneId) =>
      currentZoneId ? currentZoneId : String(allZones[0].zoneId)
    );
  }, [allZones]);

  const vehcileTypeData = async () => {
    try {
      const response = await AllVehicleTypeDetails();
      setVehicleTypeDetails(response);
      // setOriginalData(response);
    } catch (error) {
      console.error("Error fetching shift data:", error);
    }
  };
// Add this helper near fetchImageAsBase64Excel
const getCleanImageUrl = (url) => {
  if (!url || url === "N/A") return null;
  return url.split("?t=")[0]; // strip cache-bust param
};

  const handleEditData = (row) => {
    if (row && Object.keys(row).length > 0) {
      const cleanedRow = {
        ...row,
        netWeight: row.netWeight === "N/A" ? "" : row.netWeight,
        grossWeight: row.grossWeight === "N/A" ? "" : row.grossWeight,
      };
      setEditData(cleanedRow);
      setLgShow(true);
    }
  };

  useEffect(() => {
    vehcileTypeData();
  }, []);
  const fetchTripsTonnageData = async (
    startDate,
    endDate,
    VehicleNumber,
    zoneId,
    circleId,
    collectionTypeId,
    ownerTypeId,
    VehicleTypeId,
    transferStationId,
  ) => {
    setIsLoading(true);
    try {
      const response = await AllTransferStationTransactions(
        startDate,
        endDate,
        VehicleNumber,
        zoneId,
        circleId,
        collectionTypeId,
        ownerTypeId,
       VehicleTypeId ,
        transferStationId,
      );
      
          const fetchTimestamp = Date.now();

      const formattedData = response.data.map((item) => ({
        ...item,
        image: item?.vehicleImageUrl, // Include vehicleImageUrl in the data
        tsincharge: item?.transferStationInchargeName || "N/A",
        tsname: item?.transferStationName || "N/A",
        vehicleUid: item?.vehicleUuid || "N/A",
        latitude: item?.scannedLatitude || "N/A",
        longitude: item?.scannedLongitude || "N/A",
        deploymentDate: item?.scannedDate || "N/A",
        zone: item?.zoneName || "N/A",
        ward: item?.circleName || "N/A",
        // image: item?.vehicleImageUrl || "N/A",
        vehicleType: item?.vehicleTypeName || "N/A",
        ownerType: item?.ownerTypeName || "N/A",
        netWeight: item.netWeight || "N/A",
        grossWeight: item?.grossWeight || "N/A",
        tareWeight: item?.tareWeight || "N/A",
        lmcSlipNO: item?.lmcSlipNO || "", 
         "Slip Image": item?.beforePicture && item.beforePicture !== "N/A"
        ? `${item.beforePicture}?t=${fetchTimestamp}&_=${item.updatedDate || fetchTimestamp}`
        : "N/A",        
      }));
      setAllTripsTonnage(formattedData);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  
  // fetching zone data
  
  
  const fetchAllDataDetails = async () => {
    try {
      const zonesData = await GetZone();
      const delhiZones = (Array.isArray(zonesData) ? zonesData : []).filter(
        (zone) =>
          zone.isActive !== false &&
          String(zone.zoneName || "").toLowerCase().includes("delhi")
      );
      setAllZones(delhiZones);
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    // Convert selected vehicle types array to comma-separated string
    // Only pass the string if there are selections, otherwise pass empty string
  const vehicleTypeIds = selectedVehicleTypes.length > 0
    ? selectedVehicleTypes.map(v => v.value).join(",")  // e.g. "1,3,5"
    : "";
    fetchTripsTonnageData(
      startDate,
      endDate,
      VehicleNumber,
      zoneId,
      "",
      "",
      "",
      vehicleTypeIds,
      "",
    );
  };

  const formatDateForDisplay = (dateString) => {
    const date = new Date(dateString);
    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    return date.toLocaleString("en-GB", options).replace(",", "");
  };
  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date()
    .toLocaleString("en-GB", options)
    .replace(/\//g, "/")}`;

  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1
      }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `TransferStation Transaction Reports (${formatDateForDisplay(startDate)} to ${formatDateForDisplay(endDate)}) (at ${getCurrentDateTime1()})`;
    const downloadDateTime = `Report on: ${generationTime},${formattedTime}`;
    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");
    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
    worksheet.mergeCells(1, 2, 1, 11); // Merge cells for downloadDateTime from column 2 to 4
    worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
    worksheet.getCell(1, 2).font = boldFont; // Set font style
    worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B1, C1, D1)
    for (let col = 2; col <= 11; col++) {
      worksheet.getCell(1, col).font = boldFont; // Set styles individually
      worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add "Zone Details" to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", cumulativeHeadingReport, ""]); // Update array length to match new cell range
    worksheet.mergeCells(2, 2, 2, 11); // Merge cells for Zone Details from column 2 to 4
    worksheet.getCell(2, 2).value = cumulativeHeadingReport; // Ensure the value is set after merging
    worksheet.getCell(2, 2).font = boldFont; // Set font style
    worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B2, C2, D2)
    for (let col = 2; col <= 14; col++) {
      worksheet.getCell(2, col).font = boldFont; // Set styles individually
      worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Vehicle UID",
      "Vehicle Number",
      "Zone",
      "Ward",
      "Vehicle Type",
      "Owner Type",
      "TS Incharge",
      "TS Name",
      "Deployment Date",
      "Net Weight",
      "Gross Weight",
      "Latitude",
      "Longitude",
      "Address",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Left align the cell content
      if (colNumber >= 1 && colNumber <= 19) {
        // Apply background color only to specific cells
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
        };
      }
    });

    // Add data rows
    getAllTripsTonnage.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.vehicleUuid ?? "N/A",
          item.vehicleNumber ?? "N/A",
          item.zoneName ?? "N/A",
          item.circleName ?? "N/A",
          item.vehicleTypeName ?? "N/A",
          item.ownerTypeName ?? "N/A",
          item.transferStationInchargeName ?? "N/A",
          item.transferStationName ?? "N/A",
          item.scannedDate ?? "N/A",
          item.netWeight ?? "N/A",
          item.grossWeight ?? "N/A",
          item.scannedLatitude ?? "N/A",
          item.scannedLongitude ?? "N/A",
          item.address ?? "N/A",
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 19) {
            // Align the columns from 1 to 4 to the left
            cell.alignment = {
              horizontal: "left",
              vertical: "middle",
              wrapText: true,
            };
          } else {
            // Align the rest of the columns to the center
            cell.alignment = {
              horizontal: "center",
              vertical: "middle",
              wrapText: true,
            };
          }
        });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 100 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "TransferstationTransactionReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };


  const dowanloadExcel = async () => {
    setIsExcelDowanload(true);
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL1}RawReport/GetAllTransferStationTransactionExcelSheet`,
        {
          params: {      
           startDate,
           endDate,
          ZoneId: zoneId,
          // VehicleTypeId: selectedVehicleTypes.map(v => v.value).join(","),
VehicleTypeIds: selectedVehicleTypes.length > 0 
  ? selectedVehicleTypes.map(v => v.value).join(",") 
  : undefined,
          VehicleNumber
          },
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
          responseType: "blob", // 🔥 VERY IMPORTANT
        },
      );

      // ✅ Create downloadable file
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "Transfer Station Transaction Report.xlsx"; // or backend filename
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Excel download failed", error);
    } finally {
      setIsExcelDowanload(false);
    }
  };

  const exportPdf = async () => {
    await exportToPDF({
      fileName: "Transferstation_Transaction_Report",
      title: "TransferStation Transaction Reports",
      generatedOnText: `Report on: ${generationTime}, ${getCurrentDateTime1()}`,
      data: getAllTripsTonnage,
      landscape: true,

      columns: [
        {
          header: "S.No",
          accessor: (_row, index) => index + 1,
          width: 10,
        },
        {
          header: "Vehicle UID",
          accessor: (row) => row.vehicleUuid ?? "N/A",
          width: 30,
        },
        {
          header: "Vehicle Number",
          accessor: (row) => row.vehicleNumber ?? "N/A",
          width: 25,
        },
        {
          header: "Zone",
          accessor: (row) => row.zoneName ?? "N/A",
          width: 22,
        },
        {
          header: "Ward",
          accessor: (row) => row.circleName ?? "N/A",
          width: 22,
        },
        {
          header: "Vehicle Type",
          accessor: (row) => row.vehicleTypeName ?? "N/A",
          width: 25,
        },
        {
          header: "Owner Type",
          accessor: (row) => row.ownerTypeName ?? "N/A",
          width: 25,
        },
        {
          header: "TS Incharge",
          accessor: (row) => row.transferStationInchargeName ?? "N/A",
          width: 30,
        },
        {
          header: "TS Name",
          accessor: (row) => row.transferStationName ?? "N/A",
          width: 30,
        },
        {
          header: "Deployment Date",
          accessor: (row) => formatDateForDisplay(row.scannedDate) ?? "N/A",
          width: 28,
        },
        {
          header: "Gross Weight",
          accessor: (row) => row.grossWeight ?? "N/A",
          width: 22,
        },
        {
          header: "Tare Weight",
          accessor: (row) => row.tareWeight ?? "N/A",
          width: 22,
        },
        {
          header: "Net Weight",
          accessor: (row) => row.netWeight ?? "N/A",
          width: 22,
        },
        //  {
        //   header: "LMC Slip No",
        //   accessor: (row) => row.lmcSlipNO ?? "N/A",
        //   width: 22,
        // },
        {
          header: "Latitude",
          accessor: (row) => row.scannedLatitude ?? "N/A",
          width: 22,
        },
        {
          header: "Longitude",
          accessor: (row) => row.scannedLongitude ?? "N/A",
          width: 22,
        },
        // {
        //   header: "Address",
        //   accessor: (row) => row.address ?? "N/A",
        //   width: 60,
        // },
        {
          header: "Vehicle Image",
          accessor: (r) => r.vehicleImageUrl || r.image || null,
          isImage: true,
          width: 20,
        },
        // {
        //   header: "Slip Image",
        //   accessor: (r) => r.beforePicture || r["Slip Image"] || null,
        //   isImage: true,
        //   width: 20,
        // },
      ],
    });
  };

const fetchImageAsBase64Excel = async (url) => {
  if (!url) return null;
  try {
    const response = await fetch(url, { mode: "cors" });
    if (!response.ok) return null;
    const blob = await response.blob();
    if (!blob.type.startsWith("image/")) return null; // guard against HTML error pages
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result.split(",")[1]);
      reader.onerror = () => resolve(null);
      reader.readAsDataURL(blob);
    });
  } catch {
    return null;
  }
};

const downloadExcelWithImages = async () => {
  const currentDate = new Date();
  const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
  const cumulativeHeadingReport = `TransferStation Transaction Reports (${formatDateForDisplay(startDate)} to ${formatDateForDisplay(endDate)}) (at ${getCurrentDateTime1()})`;
  const downloadDateTime = `Report on: ${generationTime},${formattedTime}`;

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Report");
  const boldFont = { bold: true };

  // Header rows
  worksheet.addRow(["", "", downloadDateTime]);
  worksheet.mergeCells(1, 2, 1, 11);
  worksheet.getCell(1, 2).value = downloadDateTime;
  worksheet.getCell(1, 2).font = boldFont;
  worksheet.getCell(1, 2).alignment = { horizontal: "center" };

  worksheet.addRow(["", "", cumulativeHeadingReport]);
  worksheet.mergeCells(2, 2, 2, 11);
  worksheet.getCell(2, 2).value = cumulativeHeadingReport;
  worksheet.getCell(2, 2).font = boldFont;
  worksheet.getCell(2, 2).alignment = { horizontal: "center" };

  worksheet.addRow([""]);

  // Table headers
  const tableHeaderRow = worksheet.addRow([
    "S.No", "Vehicle UID", "Vehicle Number", "Zone", "Ward",
    "Vehicle Type", "Owner Type", "TS Incharge", "TS Name",
    "Deployment Date", "Gross Weight", "Tare Weight", "Net Weight",
    "Latitude", "Longitude",
    // "Address",
  ]);

  tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
    cell.font = boldFont;
    cell.alignment = { horizontal: "left" };
    if (colNumber >= 1 && colNumber <= 17) {
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "F6B1B1" } };
    }
  });

  // Set row height for image rows and column widths
  worksheet.columns = [
    { width: 5 },  { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 },
    { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 },
    { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 },
    { width: 20 }, { width: 20 },
  ];

  // const IMAGE_ROW_HEIGHT = 75; // px approx for 100px image

  for (let i = 0; i < getAllTripsTonnage.length; i++) {
    const item = getAllTripsTonnage[i];
    const excelRowNumber = 4 + i + 1; // 3 header rows + 1 table header + data rows

    const row = worksheet.addRow([
      i + 1,
      item.vehicleUuid ?? "N/A",
      item.vehicleNumber ?? "N/A",
      item.zoneName ?? "N/A",
      item.circleName ?? "N/A",
      item.vehicleTypeName ?? "N/A",
      item.ownerTypeName ?? "N/A",
      item.transferStationInchargeName ?? "N/A",
      item.transferStationName ?? "N/A",
      item.scannedDate ?? "N/A",
      item.grossWeight ?? "N/A",
      item.tareWeight ?? "N/A",
      item.netWeight ?? "N/A",
      item.scannedLatitude ?? "N/A",
      item.scannedLongitude ?? "N/A",
      // item.address ?? "N/A",
      "", // placeholder for vehicle image
      "", // placeholder for slip image
    ]);

    // row.height = IMAGE_ROW_HEIGHT;
    // row.eachCell({ includeEmpty: true }, (cell) => {
    //   cell.alignment = { horizontal: "left", vertical: "middle", wrapText: true };
    // });

    // Embed vehicle image (col 16)
    // Embed vehicle image (col 16)
// if (item.vehicleImageUrl) {
//   const base64 = await fetchImageAsBase64Excel(getCleanImageUrl(item.vehicleImageUrl));
//   if (base64) {
//     const imageId = workbook.addImage({ base64, extension: "jpeg" });
//     worksheet.addImage(imageId, {
//       tl: { col: 15, row: excelRowNumber - 1 },
//       ext: { width: 100, height: 70 },
//     });
//   }
// }

// Embed slip image (col 17)
// if (item.beforePicture) {
//   const base64 = await fetchImageAsBase64Excel(getCleanImageUrl(item.beforePicture));
//   if (base64) {
//     const imageId = workbook.addImage({ base64, extension: "jpeg" });
//     worksheet.addImage(imageId, {
//       tl: { col: 16, row: excelRowNumber - 1 },
//       ext: { width: 100, height: 70 },
//     });
//   }
// }

  }

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "TransferstationTransactionReport_WithImages.xlsx";
  a.click();
  URL.revokeObjectURL(url);
};

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 class="text-start mb-3">
              {t("Transfer Station Transaction Report")} (
              {formatDateForDisplay(startDate)} to{" "}
              {formatDateForDisplay(endDate)}) (at {getCurrentDateTime1()})
            </h4>
            <div className="card">
              <div className="card-body p-3">
                <div className="row align-items-end">
                  <div className="col-md-12">
                    <form onSubmit={handleFormSubmit}>
                      <div className="row text-start">
                        <div className="col-md-2">
                          <label>From Date & Time:</label>
                          <input
                            type="datetime-local"
                            name="FromDate"
                            style={inputStyle}
                            value={startDate}
                            className="form-control"
                            max={endDate ? endDate : getCurrentDateTime()}
                            onChange={(e) => setStartDate(e.target.value)}
                          />
                        </div>

                        <div className="col-md-2">
                          <label>To Date & Time:</label>
                          <input
                            type="datetime-local"
                            name="ToDate"
                            style={inputStyle}
                            value={endDate}
                            className="form-control"
                            min={startDate}
                            max={getCurrentDateTime()}
                            onChange={(e) => setEndDate(e.target.value)}
                          />
                        </div>

                        <div className="col-md-3">
                          <label htmlFor="VehicleTypeId">Vehicle Type</label>
                          <Select
                            className="basic-multi-select"
                            classNamePrefix="select"
                            isMulti
                            name="vehicleTypes"
                            options={vehicleTypeDetails
                              .filter((v) => v.isActive)
                              .map((v) => ({
                                value: v.vehicleTypeId,
                                label: v.vehicleTypeName,
                              }))}
                            value={selectedVehicleTypes}
                            onChange={(selected) => setSelectedVehicleTypes(selected || [])}
                            placeholder="Select Vehicle Types"
                            isClearable
                          />
                        </div>

                        <div className="col-md-3">
                          <label>Vehicle Number</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Vehicle Number"
                            value={VehicleNumber}
                            onChange={(e) =>
                              setVehicleNumber(
                                e.target.value.replace(/\s+/g, ""),
                              )
                            }
                          />
                        </div>

                        {/* <div className="col-md-3">
                          <label>Zone</label>
                          <select
                            className="form-select"
                            value={zoneId}
                            onChange={(e) => setZoneId(e.target.value)}
                          >
                            {allZones.map((z) => (
                              <option key={z.zoneId} value={z.zoneId}>
                                {z.zoneName}
                              </option>
                            ))}
                          </select>
                        </div> */}

                        <div className="col-md-2 ">
                          <button
                            type="submit"
                            className={`btn mt-4 w-50 ${isProd ? "search-ghmc" : "search-swm"
                              }`}
                          >
                            Search
                          </button>
                        </div>

                       <div className="col-md-12 d-flex gap-2 justify-content-end mt-4 flex-wrap">
  <button
    className="btn btn-excel"
    onClick={dowanloadExcel}
    style={{ minWidth: 110 }}
  >
    {IsExcelDowanload ? <SmallLoader /> : (
      <span>
        <i className="fa-solid fa-file-excel me-1 icon-container"></i>
        Excel + Image
      </span>
    )}
  </button>

  <button
    className="btn btn-excel"
    onClick={downloadExcelWithImages}
    style={{ minWidth: 100 }}
  >
    <i className="fa-solid fa-file-excel me-1 icon-container"></i>
    Excel 
  </button>


  <button
    type="button"
    className="btn btn-excel"
    onClick={exportPdf}
    style={{ minWidth: 90 }}
  >
    <i className="fa-solid fa-file-pdf me-1"></i>
    PDF
  </button>
</div>
                      </div>
                    </form>
                  </div>
                </div>

                <div className="mt-3">
                  <TableComponent isLoading={isLoading}
                   key={JSON.stringify(getAllTripsTonnage)}
                    DataFetchURL={getAllTripsTonnage}
                    headers={headers}
                    editData={handleEditData}
                    filterFunction={(data) => data} // Show all data
                  />
                </div>
                {lgShow ? (
                  <EditTransferstationTransactionModal
                    selectedData={editData}
                    showModal={lgShow}
                    setEditData={setEditData}
                    setShow={setLgShow}
                    startDate={startDate}
                    endDate={endDate}
                    VehicleNumber={VehicleNumber}
                    zoneId={zoneId}
                    VehicleTypeId={selectedVehicleTypes.map(v => v.value).join(",")}
                    AllTransferStationTransactions={fetchTripsTonnageData}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// Function to get the start of the current date (00:00 AM)
const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};

// Styles for input and button
const inputStyle = {
  border: "1px solid #E2E2E2",
  // padding: "15px",
};
const FilterInputStyle = {
  height: "38px",
  borderRadius: "4px",
  border: "1px solid #ced4da",
  paddingLeft: "10px",
  width: "100%",
};
const buttonStyle = {
  border: "1px solid #E2E2E2",
  // borderRadius: "5px",
  // color: "#fff",
};

export default withTranslation()(TransferStationTransaction);
